import slick from 'slick-carousel';
$('.leaf-content-wide-content-image').slick({
  dots: true,
  arrows: false,
  infinite: true,
  fade: true,
  speed: 1000,
  autoplay: false
});
$('.leaf-content-mobile-image').slick({
  dots: true,
  arrows: false,
  infinite: true,
  fade: true,
  speed: 1000,
  autoplay: false
});
$('.leaf-content-mobile-content').slick({
  dots: false,
  arrows: true,
  infinite: true // adaptiveHeight: true

});